export const ALERT_EXPORT_ALLOTMENT_NODES: number[] = [2652, 319, 5708, 5842, 1193];
